import { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from "@sentry/react";
import { openChatwootChat } from '@utils/chatwoot';
import BaseDialog from './BaseDialog';
/*
    4 ways to contact support:
    1. Chatwoot widget (primary), has bot and human support
    2. Telegram bot (secondary), direct message to team, only when need to contact human support
    3. Sentry feedback form (secondary), for reporting technical issues and bugs, automatically includes error context
    4. Telegram group (secondary), for general questions and discussions, not for support
*/
const TechSupportPopup = ({ isOpen, closePopup, openChat = false }) => {
    // ?support=chat: open the chat bubble together with the modal
    useEffect(() => {
        if (isOpen && openChat) {
            openChatwootChat();
        }
    }, [isOpen, openChat]);

    const handleAskQuestion = () => {
        const telegramLink = import.meta.env.VITE_TELEGRAM_SUPPORT_LINK || 'https://t.me/c/1185566598/2965';
        window.open(telegramLink, '_blank');
        closePopup();
    };

    const handleReportProblem = async () => {
        closePopup();
        const feedback = Sentry.getFeedback();
        const form = await feedback?.createForm();
        form?.appendToDom();
        form?.open();
    };

    const handleChatwoot = () => {
        // chatwoot sdk to open chat widget
        if (window.$chatwoot) {
            window.$chatwoot.toggle();
        }
    };

    return (
        <BaseDialog isOpen={isOpen} onClose={closePopup} title="Техническая поддержка">
            <div className="subscription-info">
                <p>
                    Выберите категорию обращения:
                </p>
                <p style={{ fontSize: 'clamp(12px, 1.2vw, 13px)', color: '#666', marginTop: '0.3rem' }}>
                    <strong>Чат</strong> - для вопросов по работе сайта и функционала
                </p>
                <p style={{ fontSize: 'clamp(12px, 1.2vw, 13px)', color: '#666', marginTop: '0.3rem' }}>
                    <strong>Группа Телеграм</strong> - для общих вопросов и обсуждений
                </p>
                <p style={{ fontSize: 'clamp(12px, 1.2vw, 13px)', color: '#666', marginTop: '0.3rem' }}>
                    <strong>Сообщить о проблеме</strong> - для технических ошибок и багов
                </p>
                <p style={ { fontSize: 'clamp(12px, 1.2vw, 13px)', color: '#666', marginTop: '0.3rem' } }>
                    <strong>Прямая связь</strong> - для прямого контакта с технической поддержкой.
                    Только в случае, если нужно связаться с человеком, а не ботом{" "}
                    <a href="https://t.me/imatranshakki_support_bot" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '0.3rem' }}>
                        <strong>Написать в Telegram</strong>
                    </a>
                </p>
               

            </div>

            <div className="button-container">
                <button onClick={ handleChatwoot }>
                    Начать чат (Chatwoot)
                </button>
                <button onClick={handleAskQuestion}>
                    Обсуждение (Telegram)
                </button>
                <button onClick={handleReportProblem}>
                    Сообщить о проблеме/баге (Sentry)
                </button>
            </div>

            <button
                className="btn-secondary"
                onClick={closePopup}
                style={{ marginTop: '1rem' }}
            >
                Закрыть
            </button>
        </BaseDialog>
    );
};

TechSupportPopup.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    closePopup: PropTypes.func.isRequired,
    openChat: PropTypes.bool,
};

export default TechSupportPopup;
